<template>
  <div>
    <el-input
      placeholder="输入文件夹进行搜索"
      v-model="filterText"
      class="input-filter"
      >
    </el-input>
    <div class="setup"><span class="el-icon-s-tools" @click="onSetting"></span></div>
    <!-- 报表文件 -->
    <el-tree
      class="sheet-tree"
      node-key="dataId"
      :data="sheetData"
      :props="defaultProps"
      :icon-class="`el-icon-folder`"
      highlight-current
      :filter-node-method="filterNode"
      :default-expanded-keys="expandedKeys"
      @node-click="handleNodeClick"
      @node-expand="handleNodeExpand"
      @node-collapse="handleNodeCollapse"
      ref="tree"
    >
      <span class="my-custom" slot-scope="{ node, data }">
        <template v-if="data.type === '1'">
          <svg class="icon svg-icon" aria-hidden="true" v-show="!node.expanded">
            <use xlink:href="#icon-folder"></use>
          </svg>
          <svg class="icon svg-icon" aria-hidden="true" v-show="node.expanded">
            <use xlink:href="#icon-opened_folder"></use>
          </svg>
        </template>
        <svg class="icon svg-icon" aria-hidden="true" v-else>
          <use xlink:href="#icon-file"></use>
        </svg>
        <span v-if="data.folderName.length <= 10">{{ data.folderName }}</span>
        <el-tooltip :content="data.folderName" placement="top">
          <span v-if="data.folderName.length > 10">{{ data.folderName }}</span>
        </el-tooltip>
      </span>
    </el-tree>
    <!-- 设置 -->
    <setting
      :visible.sync="settingVisible"
      :modulesConfig="modulesConfig"
      @complete="get_menu"
      v-if="settingVisible"
    ></setting>
  </div>
</template>

<script>
  import setting from './setting'
  import tooltips from '../directive/tooltips/index.js' 
  export default {
    components: { setting },
    props: ['modulesConfig'],
    directives: {
      tooltips
    },
    data() {
      return {
        filterText: '',
        sheetData: [],
        defaultProps: {
          children: 'children',
          label: 'nodeName'
        },
        selectVisible: false,
        settingVisible: false,
        expandedKeys: [],
        selectedData: {},
        serchDataId: [],
      }
    },
    watch: {
      filterText(val) {
        this.serchDataId = []
        this.$refs.tree.filter(val);
      },
    },
    mounted() {
      this.get_menu();
    },
    methods: {
      get_menu() {
        let data = {
          folderName: '',
          parentId: ''
        };
        return this.$q.shortVideoOverview.treeMenus({ data })
        .then(res=>{
          this.sheetData = res.data;
        })
      },
      // tree数据转平级
      tree2flat(source) {
        let res = []
        const fn = (source)=>{
          source.forEach(el=>{
            res.push(el)
            el.children && el.children.length>0 ? fn(el.children) : ""
          });
        }
        fn(source)
        return res;
      },
      // 节点点击
      handleNodeClick(data) {
        // console.log(data);
        // let type = data.children.map(v=>v.type).includes('2')
        // if(data.type === '1' && type) {
          // const wholePath = window.location.origin+'/#'+'/fileManagement'+'?type='+ data.dataId
          this.$emit('menu-click', data) 
          // this.$router.addRoute('SheetManagement', {
          //   name: `Sheet_${data.path.subString(1)}`,
          //   path: `sheet_${data.path.subString(1)}`,
          //   component: () => import('@/views/boomSheet/boomSheet'),
          //   meta: {
          //     title: '基础信息表'
          //   }
          // });
          // this.$router.push({ name: 'Sheet_boomSheet' })
        // }
      },
      // 节点展开
      handleNodeExpand(data, node, $el) {
        this.expandedKeys.push(data.dataId);
      },
      // 节点折叠
      handleNodeCollapse(data, node, $el) {
        this.expandedKeys = this.expandedKeys.filter(v=>v!=data.dataId)
        //当多层文件时折叠最多层级需过滤该层级下所有子层级key
        if(data.children && data.children.length) {
          let childrenDataId = this.tree2flat(data.children).map(v=>v.dataId)
          this.expandedKeys = this.expandedKeys.filter(v=>!childrenDataId.includes(v))
       }
      },
      filterNode(value, data, node) {
        console.log(this.serchDataId);
        if (!value) {
          node.expanded = false;
          return true;
        }
        if(data.folderName.indexOf(value)!== -1) {
          this.serchDataId.push(data.dataId)
          return true
        }else {
          return this.serchDataId.includes(data.parentId)
          
        }
        // return data.folderName.indexOf(value) !== -1 && data.children && data.children.length;
      },
      // 收藏
      // onSelect(status, data) {
      //   if(status) {
      //     // 收藏
      //     this.selectedData = data;
      //     this.selectVisible = true;
      //   }else{
      //     // 取消收藏
      //     let requestData = {
      //       appCode: this.modulesConfig.appCode,
      //       subAppCode: this.modulesConfig.subAppCode,
      //       folderId: data.parentId,
      //       reportId: data.data.reportDataId,
      //       reportName: data.nodeName,
      //       type: '2'
      //     }
      //     this.$q.sheet.favorite({data: requestData})
      //     .then(res=>{
      //       if(res.code == 200) {
      //         this.$message.success('取消收藏')
      //       }else{
      //         this.$message.error(res.message)
      //       }
      //       this.get_menu();
      //     })
      //   }
      // },
      // 设置
      onSetting() {
        this.settingVisible = true;
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .setup
    text-align right
    padding 0 10px

  >>> .el-tree-node__expand-icon
    display block
    position relative
    left -100px
  >>> .el-tree-node__content
    width 100%
    box-sizing border-box

  .sheet-tree
    position reletive 

  .my-custom
    width 100%
    display inline-block
    padding-right 36px
    // user-select none
    position relative
    overflow hidden
    text-overflow ellipsis
  .node-operate
    position absolute
    right 15px
    top 1px

  .el-icon-star-on
    font-size 18.5px
    position relative
    top -1px 
    color rgb(255,160,0)
  .el-icon-star-off
    font-size 15px
    position relative
    top -2px 
    color #999
  .el-icon-s-tools
    font-size 18px
    color #1A936F

  .input-filter
    width auto
    display block
    padding 10px
    margin-top 10px
    >>> input
      height 32px

  .icon {
    width: 18px;
    height: 18px;
    vertical-align: middle;
    overflow: hidden;
    position relative
    top -1px
  }
</style>